<template>
  <div relative>
    <ClientOnly>
      <Map v-bind="$attrs" @interact="attributionOpen = false" />
      <template #fallback>
        <div w-full h-lg bg-stone-50 flex justify-center items-center text-stone-400 text-xl>Loading map&hellip;</div>
      </template>
    </ClientOnly>
    <MapAttribution v-if="attribution" v-model:open="attributionOpen" />
  </div>
</template>
<script setup>
// other attributes are for the map, as when ClientOnly was the root
defineOptions({ inheritAttrs: false });

defineProps({
  // false when a parent rendered on the server shows the attribution instead (MapAddress)
  attribution: {
    type: Boolean,
    default: true,
  },
});

const attributionOpen = ref(true);
</script>
